function h(r, a) {
  var e = f(a);
  return e.formatToParts ? m(e, r) : c(e, r);
}
var d = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function m(r, a) {
  try {
    for (var e = r.formatToParts(a), t = [], n = 0; n < e.length; n++) {
      var o = d[e[n].type];
      o >= 0 && (t[o] = parseInt(e[n].value, 10));
    }
    return t;
  } catch (u) {
    if (u instanceof RangeError)
      return [NaN];
    throw u;
  }
}
function c(r, a) {
  var e = r.format(a).replace(/\u200E/g, ""), t = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e);
  return [t[3], t[1], t[2], t[4], t[5], t[6]];
}
var i = {};
function f(r) {
  if (!i[r]) {
    var a = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), e = a === "06/25/2014, 00:00:00" || a === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    i[r] = e ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: r,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: r,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return i[r];
}
export {
  h as default
};
